<script>
import codeTable from "@/components/table";
import topBar from "./topbar";
import { columns } from "./config";
import contactItem from "./contact-item.vue";

export default {
    created() {
        this.initSelectOptions();
        this.getList();
    },
    data() {
        const contactValidator = (rule, value, callback) => {
            const hasEmpty = this.contactList.find((item) => !item.contactInfo);
            if (hasEmpty) {
                callback(new Error("联系方式不能为空"));
            } else {
                callback();
            }
        };

        return {
            pageOption: {
                data: [],
                pageQuery: {
                    total: 0,
                    pageSize: 20,
                    currentPage: 1,
                    pageSizeList: [20, 40, 60],
                },
                searchQuery: {
                    creditCode: "",
                    custName: "",
                    custType: 0,
                },
            },
            selectOption: {
                custType: [],
                contactType: [],
            },
            editParams: {},
            contactList: [],
            rowData: null,
            editVisible: false,
            rules: {
                creditCode: [{ required: true, trigger: "blur" }],
                companyName: [{ required: true, trigger: "blur" }],
                comBusinessStatus: [{ required: true, trigger: "blur" }],
                custType: [{ required: true, trigger: "blur" }],
                legalPersonName: [{ required: true, trigger: "blur" }],
                regCapital: [{ required: true, trigger: "blur" }],
                regLocation: [{ required: true, trigger: "blur" }],
                industry: [{ required: true, trigger: "blur" }],
                establishTime: [{ required: true, trigger: "blur" }],
                contactInfoList: [
                    { validator: contactValidator, trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        handleEdit(row) {
            this.rowData = row;
            this.editParams = { ...row };

            this.$http({
                method: "post",
                url: "/admin/api/company/editContactInfo",
                params: {
                    custId: row.id,
                },
            }).then((res) => {
                this.contactList = res.data.map((item) => ({
                    contactId: item.contactId, // 联系方式ID，字段为空代表新增
                    contactType: item.contactType, // 联系方式类型ID
                    contactInfo: item.contactInfo,
                }));
                this.editVisible = true;
            });
        },
        initSelectOptions() {
            this.$http({
                method: "post",
                url: "/admin/api/company/init",
                params: {},
            }).then((res) => {
                const data = res.data;
                this.selectOption.custType = data.custType.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                this.selectOption.contactType = data.contactType.map(
                    (item) => ({
                        value: item.id,
                        label: item.name,
                    })
                );
            });
        },
        onSubmit() {
            const url = this.isEdit
                ? "/admin/api/company/editCompany"
                : "/admin/api/company/addCompany";
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$http({
                        method: "post",
                        url,
                        params: {
                            ...(this.isEdit ? { id: this.rowData.id } : {}),
                            creditCode: this.editParams.creditCode,
                            companyName: this.editParams.companyName, // 企业名称
                            comBusinessStatus:
                                this.editParams.comBusinessStatus, // 企业状态
                            legalPersonName: this.editParams.legalPersonName, // 法人
                            establishTime: this.editParams.establishTime, // 成立日期
                            regCapital: this.editParams.regCapital, // 注册资本
                            regLocation: this.editParams.regLocation,
                            industry: this.editParams.industry,
                            custType: this.editParams.custType, //  企业类型ID
                            contactInfoList: this.contactList.slice(),
                        },
                    }).then((res) => {
                        this.editVisible = false;
                        this.rowData = null;
                        this.contactList = [];
                        this.getList();
                    });
                }
            });
        },
        change({ value, type }) {
            this.pageOption.pageQuery.currentPage = 1;
        },
        async getList() {
            this.$loading(true);
            const { pageQuery, searchQuery } = this.pageOption;
            const { pageSize, currentPage } = pageQuery;
            try {
                const { data } = await this.$http({
                    method: "post",
                    url: "/admin/api/company/selectCompanyList",
                    params: {
                        ...searchQuery,
                        pageSize,
                        pageNum: currentPage,
                    },
                });
                this.pageOption.data = (data && data.result) || [];
                this.pageOption.pageQuery.total = data && data.total;
            } catch (e) {
                throw e;
            } finally {
                this.$loading(false);
            }
        },
        addContactItem() {
            this.contactList.push({
                contactId: "",
                contactType: 0,
                contactInfo: "",
            });
        },
        handleContactItemChange(val, index) {
            this.$set(this.contactList, index, val);
        },
        handleContactItemDel(index) {
            this.contactList.splice(index, 1);
        },
        handleContactItemDown(index) {
            const nextIndex = index + 1;
            const currentItem = this.contactList[index];
            const nextItem = this.contactList[nextIndex];
            if (nextItem) {
                this.$set(this.contactList, nextIndex, currentItem);
                this.$set(this.contactList, index, nextItem);
            }
        },
        handleContactItemUp(index) {
            const prevIndex = index - 1;
            const currentItem = this.contactList[index];
            const prevItem = this.contactList[prevIndex];
            if (prevItem) {
                this.$set(this.contactList, prevIndex, currentItem);
                this.$set(this.contactList, index, prevItem);
            }
        },
        handleAdd() {
            this.editParams = {};
            this.contactList = [];
            this.rowData = null;
            this.editVisible = true;
        },
    },
    computed: {
        columns() {
            return columns;
        },
        isEdit() {
            return !!this.rowData;
        },
        title() {
            return this.isEdit ? "编辑" : "新增";
        },
    },
    watch: {
        editVisible(val) {
            if (!val) {
                this.contactList = [];
            }
        },
    },
    components: {
        codeTable,
        topBar,
        contactItem,
    },
};
</script>
<template>
    <div class="rule-list">
        <top-bar
            :handlerCodeSearch="getList"
            :searchQuery="pageOption.searchQuery"
            :selectOption="selectOption"
            @change="change"
            @add="handleAdd"
        ></top-bar>
        <code-table
            :data="pageOption.data"
            :columns="columns"
            :searchEvent="getList"
            :pageOptions="pageOption.pageQuery"
        >
            <el-table-column
                label="操作"
                align="center"
                width="120"
                fixed="right"
                slot="operate"
            >
                <template slot-scope="scope">
                    <el-button type="success" @click="handleEdit(scope.row)"
                        >编辑</el-button
                    >
                </template>
            </el-table-column>
        </code-table>

        <el-dialog
            :title="title"
            :visible.sync="editVisible"
            width="550px"
            :close-on-click-modal="false"
        >
            <el-form
                :model="editParams"
                :rules="rules"
                ref="ruleForm"
                class="form"
                label-width="135px"
            >
                <el-form-item label="统一社会信用编码" prop="creditCode">
                    <el-input
                        v-model="editParams.creditCode"
                        :disabled="isEdit"
                    ></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="editParams.companyName"></el-input>
                </el-form-item>
                <el-form-item label="法人" prop="legalPersonName">
                    <el-input v-model="editParams.legalPersonName"></el-input>
                </el-form-item>
                <el-form-item label="成立日期" prop="establishTime">
                    <el-date-picker
                        v-model="editParams.establishTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="成立日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="注册资本" prop="regCapital">
                    <el-input v-model="editParams.regCapital"></el-input>
                </el-form-item>
                <el-form-item label="注册地址" prop="regLocation">
                    <el-input
                        type="textarea"
                        :rows="3"
                        v-model="editParams.regLocation"
                    ></el-input>
                </el-form-item>
                <el-form-item label="行业" prop="industry">
                    <el-input v-model="editParams.industry"></el-input>
                </el-form-item>
                <el-form-item label="企业状态" prop="comBusinessStatus">
                    <el-input v-model="editParams.comBusinessStatus"></el-input>
                </el-form-item>
                <el-form-item label="企业类型" prop="custType">
                    <el-select
                        v-model="editParams.custType"
                        placeholder="请选择企业状态"
                    >
                        <el-option
                            v-for="item in selectOption.custType"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                        />
                    </el-select>
                </el-form-item>

                <div class="sub-title">
                    <span style="margin-right: 10px">联系方式</span>
                    <el-button @click="addContactItem">新增</el-button>
                </div>

                <el-form-item prop="contactInfoList" label-width="30px">
                    <contact-item
                        v-for="(item, index) in contactList"
                        :value="item"
                        :key="index"
                        :selectOption="selectOption.contactType"
                        @change="(val) => handleContactItemChange(val, index)"
                        @up="handleContactItemUp(index)"
                        @down="handleContactItemDown(index)"
                        @del="handleContactItemDel(index)"
                    />
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
.form {
    padding-right: 15px;
    .sub-title {
        font-size: 14px;
        margin-bottom: 15px;
        margin-left: 67px;
    }
}
</style>
